import React from 'react';
import { useTranslation } from "react-i18next";
import { db } from "../controllers/DB";
import { generateID } from "../controllers/misc";
import Api from "../api/api-wizard";

function Home() {

  if (localStorage.getItem("wizardID") == null)
    generateID(true, 'wizardID');

  const { t } = useTranslation();
  const [steps, setData] = React.useState(async () => {
    db.steps.get(localStorage.getItem("wizardID")).then(async dat => {

      if (typeof (dat) == "undefined") {

        getModules((_modules) => {

          const StepsData = {
            id: localStorage.getItem("wizardID"),
            type: '2',
            team_size: '',
            plan: '',
            company: '',
            phone: '',
            name: '',
            country: '',
            countries: [],
            address: '',
            business_type: '',
            business_description: '',
            business_email: '',
            packs: [],
            templates: [],
            currPack: {
              nombre: "",
              descripcion: "",
              script: {}
            },
            date: Math.random(),
            modules: _modules,
            hour: '09:00',
            date_start: new Date().toLocaleDateString("es-US")
          };

          setData(StepsData);

          setTimeout(() => {
            db.steps.add(StepsData);
          }, 500);
        });

      } else {
        setData(dat);
      }
    });
  }),
    [isLoaded, set_isLoaded] = React.useState(false),
    [Modules, set_modules] = React.useState([]),
    [Countries, set_Countries] = React.useState([]),
    [emptyModules, set_emptyModules] = React.useState(false);

  const saveAccount = (steps) => {

    if (typeof (steps.id) != "undefined")
      Api.put({ url: '/account/add', params: steps })
        .then(data => {
          console.log(data);
        })
        .catch(err => {
          console.log(err);
        });
  }

  const getModules = (next) => {
    Api.get({
      url: '/modules', params: {
        module: '5ee9362680f9',
        field: '106'
      }
    })
      .then(data => {
        next(data.data.modules);
      })
      .catch(err => {

      });
  }

  const getCountries = (next) => {
    Api.get({ url: '/countries', params: {} })
      .then(data => {

        data.data.countries = data.data.countries.sort(function (a, b) {
          return a.nom.localeCompare(b.nom);
        });

        set_Countries(data.data.countries);
        next();
      })
      .catch(err => {

      });
  }

  const changeModule = (ev) => {

    ev.target.id = ev.target.id.replace(/foot/g, '');
    const currMod = steps.modules.filter(fil => fil.id == ev.target.id)[0];
    currMod.selected = ev.target.checked;

    steps.modules = steps.modules;
    db.steps.update(localStorage.getItem("wizardID"), steps);
  }

  const goRegister = () => {

    set_emptyModules(false);

    if (steps.modules.filter(fil => fil.selected).length == 0) {
      set_emptyModules(true);
    } else {

      steps.countries = Countries;
      db.steps.update(localStorage.getItem("wizardID"), steps);

      const params = window.location.href.split("?");

      if (params.length > 1) {
        window.location.href = `/register?${params[1]}`;
      } else {
        window.location.href = '/register';
      }
    }
  }

  const currTheme = "blue";
  const themeOpts = {
    indigo: {
      background: "#fab91d",
      color1: "white",
      color2: "#000"
    },
    blue: {
      background: "#4f6d91",
      color1: "white",
      color2: "#FFF"
    },
    white: {
      background: "#070926",
      color1: "white",
      color2: "#FFF"
    }
  }

  React.useEffect(() => {

    db.steps.get(localStorage.getItem("wizardID")).then(dat => {

      if (typeof (dat) != "undefined") {
        db.steps.update(localStorage.getItem("wizardID"), steps);
        //saveAccount(steps);
      }
    });

    getCountries(() => {
      setTimeout(() => {

        fetch(`https://ipapi.co/json/`)
          .then(response => response.json())
          .then(data => {

            const currCountry = Countries.filter(fil => fil.iso2 == data.country_code)[0];

            if (typeof (currCountry) != "undefined") {
              steps.country = currCountry.id.toString();
              db.steps.update(localStorage.getItem("wizardID"), steps);
            }
          });

        set_isLoaded(true);
      }, 1000);
    });

  }, []);

  return (
    <div>

      <header class="site-header">
        <div id="header-wrap">
          <div class="container">
            <div class="row">
              <div class="col">
                <nav class="navbar navbar-expand-lg navbar-light">
                  <a class="navbar-brand logo text-dark h2 mb-0" href="/">
                    <img src="https://signuseducation.com/wp-content/uploads/2021/02/edu-logo-1-211x55.png" height="45" />
                  </a>
                  <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
                    aria-expanded="false" aria-label="Toggle navigation"> <span class="navbar-toggler-icon"></span>
                  </button>
                  <div class="collapse navbar-collapse" id="navbarNav">
                    <ul class="navbar-nav ms-auto">
                      <li class="nav-item dropdown"> <a class="nav-link" href="https://signuseducation.com/caracteristicas/"
                        target="_blank">Alcances</a> </li>
                      <li class="nav-item dropdown"> <a class="nav-link" href="https://signuseducation.com/"
                        target="_blank">¿Por qué destacamos?</a> </li>
                      <li class="nav-item dropdown"> <a class="nav-link" href="https://signuseducation.com/contacto/"
                        target="_blanck">Contacto</a> </li>
                    </ul>
                  </div>
                  <a class="btn btn-primary ms-8 d-none d-md-block"
                    href="https://signuseducation.com/acerca-de/"
                    target="_blank">¿Quiénes somos?</a>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </header>

      <section style={{ background: themeOpts[currTheme].background, color: themeOpts[currTheme].color1 }}>
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12 col-lg-8 text-center">
              <h4>Creada para <span class="typer" style={{ color: "#0baebb" }}
                data-words="Colegios, Academias, Centros de enseñanza"></span>
                <span style={{ fontSize: "1.2em", verticalAlign: "middle" }} class="cursor" data-cursorDisplay="|"
                  data-owner="some-id"></span>
              </h4>
              <h1 class="display-4 mt-3 font-w-5">
                La Plataforma Educativa <br />más práctica, moderna y en crecimiento de la región
              </h1>
              <p class="lead" style={{ color: themeOpts[currTheme].color2 }}>Con SignusEducation puedes brindar atención centralizada a profesores, alumnos, personal administrativo interno y padres de familia<br />
                <br />¿Que te gustaría gestionar?</p>
              <div style={{ width: "100%", marginTop: "50px", textAlign: "center" }}>
                {isLoaded && steps.modules.map((mod) => {
                  return <div key={mod.id} style={{ marginBottom: "10px", display: "inline-flex", marginRight: "10px", border: `2px solid ${mod.color}`, borderRadius: "5px", padding: "5px" }}>
                    <input defaultChecked={mod.selected} class="form-check-input" onChange={changeModule} type="checkbox" value="" id={mod.id} />
                    <label class="form-check-label mb-0" for={mod.id} style={{ color: themeOpts[currTheme].color2 }}>
                      &nbsp;{mod.name}
                    </label>
                  </div>
                })}
              </div><br />
              <button class="btn btn-primary" onClick={goRegister}>Asesoría</button><br />
              {emptyModules && <label class="text-warning">Elija al menos una opción para continuar.</label>}
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-12 col-lg-10">
              <div class="position-relative">
                <img src="https://files.signuscorp.com/?business=1&file=MTYzMTdjMzUwNGQ4ZTQ=" class="img-fluid" alt="SignusEducation" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="page-content">
        <section class="text-center p-0">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-xl-6 col-lg-4 mb-8 mb-lg-0">
                <div class="px-4 py-7 rounded hover-translate" data-bg-color="rgba(19, 96, 239, 0.01)">
                  <div>
                    <img src="assets/images/icons/1.png" height="100" />
                  </div>
                  <h5 class="mt-4 mb-3">Información centralizada, en tiempo real y en línea</h5>
                  <p class="mb-0">Información centralizada, en tiempo real y en línea.</p>
                </div>
              </div>
              <div class="col-xl-3 col-lg-4 col-sm-6">
                <div class="px-4 py-7 rounded hover-translate">
                  <div>
                    <img src="assets/images/icons/3.png" height="100" />
                  </div>
                  <h5 class="mt-4 mb-3">Adaptabilidad y flexibilidad</h5>
                  <p class="mb-0">Brindamos un ambiente que permite la adaptabilidad y flexibilidad en sus procesos educativos sin perder el control y orden del modelo educativo de la institución.</p>
                </div>
              </div>
              <div class="col-xl-3 col-lg-4 col-sm-6 mt-6 mt-sm-0">
                <div class="px-4 py-7 rounded hover-translate">
                  <div>
                    <img src="assets/images/icons/2.png" height="100" />
                  </div>
                  <h5 class="mt-4 mb-3">Accesos por rol educativo</h5>
                  <p class="mb-0">Accesos por rol educativo.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div class="container">
            <div class="row align-items-center justify-content-between">
              <div class="col-12 col-lg-6 mb-6 mb-lg-0">
                <img src="assets/images/issueedu.png" alt="Problemas de la educación"
                  class="img-fluid" />
              </div>
              <div class="col-12 col-lg-6 col-xl-5">
                <div> <span class="badge badge-primary-soft p-2">
                  <i class="la la-exclamation ic-3x rotation"></i>
                </span>
                  <h2 class="mt-3">Sin SignusEducation</h2>
                  <p class="lead">La educación no tiene porque ser un sinfín de acciones repetitivas sin crecimiento y sin análisis de resultados. Sin una SignusEducation puedes estar pasando estos dolores:</p>
                </div>
                <div class="d-flex flex-wrap justify-content-start">
                  <div class="mb-3 me-4">
                    <div class="d-flex align-items-center">
                      <div class="badge-waning-soft rounded p-1">
                        <i class="ti-close me-1 text-warning"></i>
                      </div>
                      <p class="mb-0 ms-3 text-warning">Información educativa sin bitácora de consulta</p>
                    </div>
                  </div>
                  <div class="mb-3 me-4">
                    <div class="d-flex align-items-center">
                      <div class="badge-waning-soft rounded p-1">
                        <i class="ti-close me-1 text-warning"></i>
                      </div>
                      <p class="mb-0 ms-3 text-warning">Herramientas educativas dispersas</p>
                    </div>
                  </div>
                  <div class="mb-3 me-4">
                    <div class="d-flex align-items-center">
                      <div class="badge-waning-soft rounded p-1">
                        <i class="ti-close me-1 text-warning"></i>
                      </div>
                      <p class="mb-0 ms-3 text-warning">Herramientas educativas dispersas</p>
                    </div>
                  </div>
                  <div class="mb-3 me-4">
                    <div class="d-flex align-items-center">
                      <div class="badge-waning-soft rounded p-1">
                        <i class="ti-close me-1 text-warning"></i>
                      </div>
                      <p class="mb-0 ms-3 text-warning">Procesos operativos repetitivos desgastantes</p>
                    </div>
                  </div>
                  <div class="mb-3 me-4">
                    <div class="d-flex align-items-center">
                      <div class="badge-waning-soft rounded p-1">
                        <i class="ti-close me-1 text-warning"></i>
                      </div>
                      <p class="mb-0 ms-3 text-warning">Inconformidad de padres sobre la información de avances</p>
                    </div>
                  </div>
                  <div class="mb-3 me-4">
                    <div class="d-flex align-items-center">
                      <div class="badge-waning-soft rounded p-1">
                        <i class="ti-close me-1 text-warning"></i>
                      </div>
                      <p class="mb-0 ms-3 text-warning">Dependencia absoluta de la asistencia de profesores</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="custom-pt-1 custom-pb-2 bg-dark position-relative" data-bg-img="assets/images/bg/02.png">
          <div class="container">
            <div class="row align-items-end">
              <div class="col-lg-4 col-md-6 mb-8 mb-lg-0 text-white">
                <div> <span class="badge badge-primary-soft p-2">
                  <i class="la la-cubes ic-3x rotation"></i>
                </span>
                  <h2 class="mt-3 mb-0">Con SignusEducation</h2>
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="bg-primary-soft rounded p-5">
                  <div class="d-flex align-items-center mb-4">
                    <div class="me-3">
                      <img class="img-fluid" src="assets/images/icon/01.svg" alt="" />
                    </div>
                    <h5 class="m-0 text-light">Datos ordenados</h5>
                  </div>
                  <p class="mb-0">Datos ordenados con históricos y bitácoras de consulta en línea y tiempo real.</p>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 mt-6 mt-md-0">
                <div class="bg-primary-soft rounded p-5">
                  <div class="d-flex align-items-center mb-4">
                    <div class="me-3">
                      <img class="img-fluid" src="assets/images/icon/02.svg" alt="" />
                    </div>
                    <h5 class="m-0 text-light">APP</h5>
                  </div>
                  <p class="mb-0">App para consulta móvil de contenidos, actividades e información financiera por alumno.</p>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 mt-6">
                <div class="bg-primary-soft rounded p-5">
                  <div class="d-flex align-items-center mb-4">
                    <div class="me-3">
                      <img class="img-fluid" src="/assets/images/icon/03.svg" alt="" />
                    </div>
                    <h5 class="m-0 text-light">Acceso</h5>
                  </div>
                  <p class="mb-0">Acceso a información de desempeño por alumno en tiempo real.</p>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 mt-6">
                <div class="bg-primary-soft rounded p-5">
                  <div class="d-flex align-items-center mb-4">
                    <div class="me-3">
                      <img class="img-fluid" src="assets/images/icon/04.svg" alt="" />
                    </div>
                    <h5 class="m-0 text-light">Reportes</h5>
                  </div>
                  <p class="mb-0">Reportes e informes personalizables basados en la información ingresada por profesores y personal administrativo.</p>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 mt-6">
                <div class="bg-primary-soft rounded p-5">
                  <div class="d-flex align-items-center mb-4">
                    <div class="me-3">
                      <img class="img-fluid" src="assets/images/icon/05.svg" alt="" />
                    </div>
                    <h5 class="m-0 text-light">Resultados</h5>
                  </div>
                  <p class="mb-0">Acceso a resultados y avances desde Web y App con retroalimentación en tiempo real.</p>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 mt-6">
                <div class="bg-primary-soft rounded p-5">
                  <div class="d-flex align-items-center mb-4">
                    <div class="me-3">
                      <img class="img-fluid" src="../assets/images/icon/05.svg" alt="" />
                    </div>
                    <h5 class="m-0 text-light">Transformar</h5>
                  </div>
                  <p class="mb-0">Transformar sus proceso de enseñanza y administrativos en un Campus Virtual Educativo.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="shape-1" style={{ height: "150px", overflow: "hidden" }}>
            <svg viewBox="0 0 500 150" preserveAspectRatio="none" style={{ height: "100%", width: "100%" }}>
              <path d="M0.00,49.98 C150.00,150.00 271.49,-50.00 500.00,49.98 L500.00,0.00 L0.00,0.00 Z"
                style={{ stroke: "none", fill: "#fff" }}></path>
            </svg>
          </div>
          <div class="shape-1 bottom" style={{ height: "200px", overflow: "hidden" }}>
            <svg viewBox="0 0 500 150" preserveAspectRatio="none" style={{ height: "100%", width: "100%" }}>
              <path d="M0.00,49.98 C150.00,150.00 349.20,-50.00 500.00,49.98 L500.00,150.00 L0.00,150.00 Z"
                style={{ stroke: "none", fill: "#fff" }}></path>
            </svg>
          </div>
        </section>

        <section class="pt-0">
          <div class="container">
            <div class="row align-items-center justify-content-between">
              <div class="col-12 col-lg-6 order-lg-1 mb-6 mb-lg-0">
                <img src="https://files.signuscorp.com/?business=1&file=MTYzMDVhNGJkOTk5OWM=" alt="Image"
                  class="img-fluid" />
              </div>
              <div class="col-12 col-lg-6 col-xl-5">
                <div> <span class="badge badge-primary-soft p-2">
                  <i class="la la-exclamation ic-3x rotation"></i>
                </span>
                  <h2 class="mt-3">SignusEducation ¡Enfócate en alcanzar el éxito!</h2>
                  <p class="lead mb-5">Proveemos los servicios desde la nube de Amazon Web Services.</p>
                </div>
                <div class="d-flex align-items-center">
                  <img alt="Image" src="https://files.signuscorp.com/?business=1&file=MTYyZTJiZDM4MDU1NzA=" width="100"
                    class="shadow-primary img-fluid rounded-circle d-inline me-3" />
                  <div>
                    <h5>Ben Roger</h5>
                    <span class="text-muted">Desarrollador Web</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="position-relative">
          <div class="shape-2 transform-md-rotate" style={{ overflow: "hidden" }}>
            <svg viewBox="0 0 500 150" preserveAspectRatio="none" style={{ height: "100%", width: "100%" }}>
              <path d="M208.09,0.00 C152.70,67.10 262.02,75.98 200.80,150.00 L0.00,150.00 L0.00,0.00 Z"
                style={{ stroke: "none", fill: "#0baebb" }}></path>
            </svg>
          </div>
          <div class="container-fluid z-index-1">
            <div class="row align-items-center">
              <div class="col-12 col-md-12 col-lg-4 mb-6 mb-lg-0">
                <div> <span class="badge badge-light-soft p-2">
                  <i class="la la-users ic-3x rotation"></i>
                </span>
                  <h2 class="mt-4 text-white">Comentarios de nuestros clientes</h2>
                  <p class="lead mb-0 text-white">La plataforma educativa vino para quedarse
                    y facilitar los procesos operativos de todos los departamentos de una institución educativa no solo para profesores y alumnos.</p>
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-8">
                <div class="row">
                  <div class="col-12 col-md-6 col-lg-6">
                    <div class="card p-4 shadow border-0 flex-sm-row">
                      <div class="w-50 me-sm-5 mb-3 mb-sm-0">
                        <img alt="Image"
                          src="https://files.signuscorp.com/?business=7&file=NzViNDdiNDE0OWYyNmE="
                          width="70" class="shadow-primary img-fluid rounded-circle d-inline" />
                      </div>
                      <div class="card-body p-0">
                        <p>Puedo enriquecer el contenido académico sin tener que empezar cada año de nuevo.</p>
                        <div>
                          <h5 class="text-primary d-inline">Jorge Estrada</h5>
                          <small class="text-muted font-italic">- Director Expansión Training</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-6 mt-5">
                    <div class="card p-4 shadow border-0 flex-sm-row">
                      <div class="w-50 me-sm-5 mb-3 mb-sm-0">
                        <img alt="Image" src="https://files.signuscorp.com/?business=7&file=NzViNDdiNGQ0MDUyYzQ="
                          style={{ height: "70px" }} class="shadow-primary img-fluid rounded-circle d-inline" />
                      </div>
                      <div class="card-body p-0">
                        <p>El acompañamiento permanente me facilita la adaptación que debo dar a mis carreras y cursos.</p>
                        <div>
                          <h5 class="text-primary d-inline">Juan Manuel Bran</h5>
                          <small class="text-muted font-italic">- Director UJurídica</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-6 mt-5 mt-md-0">
                    <div class="card p-4 shadow border-0 flex-sm-row">
                      <div class="w-50 me-sm-5 mb-3 mb-sm-0">
                        <img alt="Image" src="https://files.signuscorp.com/?business=7&file=NzViNDdiNGY0ZTVhYTc="
                          width="60" class="shadow-primary img-fluid rounded-circle d-inline" />
                      </div>
                      <div class="card-body p-0">
                        <p>No solo puedo generar contenido para mis estudiantes si no además puedo velar por mis intereses financieros con pagos y estados de cuenta por estudiante.</p>
                        <div>
                          <h5 class="text-primary d-inline">Silvia Martínez</h5>
                          <small class="text-muted font-italic">- Directora ESIT</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-6 mt-5">
                    <div class="card p-4 shadow border-0 flex-sm-row">
                      <div class="w-50 me-sm-5 mb-3 mb-sm-0">
                        <img alt="Image" src="https://files.signuscorp.com/?business=7&file=NzViNDdiNDUzNzM5ZjI="
                          style={{ height: "50px" }} class="shadow-primary img-fluid rounded-circle d-inline" />
                      </div>
                      <div class="card-body p-0">
                        <p>Me permite tener control de las calificaciones por nivel, por alumno y entregar información a los padres de familia en tiempo real y bajo mi supervisión.</p>
                        <div>
                          <h5 class="text-primary d-inline">Lilian Carolina Woods</h5>
                          <small class="text-muted font-italic">- Directora Colegio Molinitos</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section style={{ background: themeOpts[currTheme].background, color: themeOpts[currTheme].color1 }}>
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-12 col-lg-8 text-center">
                <p class="lead" style={{ color: themeOpts[currTheme].color2 }}>Puedes agendar una cita, nuestros asesores se pondrán en contacto contigo en el horario que más te convenga, elije los temas sobre los que quisieras ampliar información.<br /></p>
                <div style={{ width: "100%", marginTop: "50px", textAlign: "center" }}>
                  {isLoaded && steps.modules.map((mod) => {
                    return <div key={mod.id} style={{ marginBottom: "10px", display: "inline-flex", marginRight: "10px", border: `2px solid ${mod.color}`, borderRadius: "5px", padding: "5px" }}>
                      <input defaultChecked={mod.selected} class="form-check-input" onChange={changeModule} type="checkbox" value="" id={'foot' + mod.id} />
                      <label class="form-check-label mb-0" for={'foot' + mod.id} style={{ color: themeOpts[currTheme].color2 }}>
                        &nbsp;{mod.name}
                      </label>
                    </div>
                  })}
                </div><br />
                <button class="btn btn-primary" onClick={goRegister}>Asesoría</button><br />
                {emptyModules && <label class="text-warning">Elija al menos una opción para continuar.</label>}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Home;
